<div><label class="filter-title">{{title}}</label></div>
<fieldset [attr.aria-label]="title">
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="featureIsSelected(touchscreenKeyword)"
      (change)="onFeatureChange(touchscreenKeyword)"
      (keyup.enter)="onFeatureChange(touchscreenKeyword)">
      <span class="filter-label">{{touchscreenLabel}}</span>
    </mat-checkbox>
  </div>
</fieldset>
